module.exports = __webpack_public_path__ + "img/shin.93d6356c.jpg";